
import store from '../store';
import Constants from '../config/constants';
import {serviceCreateAppUsers, serviceGetAppUsers, serviceUpdateAppUsers,serviceDeleteAppUsers} from "../services/AppUsers.service";

export const FETCH_INIT = 'FETCH_INIT_APP_USERS';
export const FETCHED = 'FETCHED_APP_USERS';
export const FETCHED_FAIL = 'FETCHED_FAIL_APP_USERS';
export const FETCH_NEXT = 'FETCH_NEXT_APP_USERS';
export const FILTER = 'FILTER_APP_USERS';
export const RESET_FILTER = 'RESET_FILTER_APP_USERS';
export const SET_SORTING = 'SET_SORTING_APP_USERS';
export const SET_FILTER = 'SET_FILTER_APP_USERS';
export const SET_PAGE = 'SET_PAGE_APP_USERS';
export const CHANGE_PAGE = 'CHANGE_PAGE_APP_USERS';
export const CHANGE_STATUS = 'CHANGE_AppUsers_APP_USERS';
export const SET_SERVER_PAGE = 'SET_SERVER_PAGE_APP_USERS';
export const CREATE_DATA = 'CREATE_APP_USERS';
export const UPDATE_DATA = 'UPDATE_APP_USERS';
export const DELETE_ITEM = 'DELETE_APP_USERS';
export const SET_CLIENT_ID = 'SET_CLIENT_ID_APP_USERS';
export const SET_PROGRAM_ID = 'SET_PROGRAM_ID_APP_USERS';

export function actionSetClientId(client_id) {
    return {
        type: SET_CLIENT_ID,
        payload: client_id
    };
}

export function actionSetProgramId(program_id) {
    return {
        type: SET_PROGRAM_ID,
        payload: program_id
    };
}

export function actionFetchAppUsers(index = 1, sorting = {}, filter = {}, shouldReset = false) {

    const stateData = store.getState().appusers;

    const client_id = stateData.client_id;

    const program_id = stateData.program_id;

    const request = serviceGetAppUsers({
        index,
        row: sorting.row,
        order: sorting.order,
        client_id,
        program_id,
        ...filter
    });

    return (dispatch) => {

        if (shouldReset) {
            dispatch({
                type: CHANGE_PAGE,
                payload: 1,
            });
        }

        dispatch({ type: FETCH_INIT });

        request.then((data) => {

            dispatch({ type: SET_FILTER, payload: filter });
            dispatch({ type: SET_SORTING, payload: sorting });

            if (!data.error) {
                dispatch({ type: FETCHED, payload: { data: data.data, page: index } });
                dispatch({ type: SET_SERVER_PAGE, payload: index });

                if (index == 1) {
                    dispatch({ type: CHANGE_PAGE, payload: index - 1 });
                }
            } else {
                dispatch({ type: FETCHED_FAIL });
            }
        });
    };
}


export function actionCreateAppUsers(data) {
    return (dispatch) => {
        serviceCreateAppUsers(data).then((data) => {
            if (!data.error) {
                dispatch({ type: CREATE_DATA, payload: data.data })
            }
        })
    }
}

export function actionUpdateAppUsers(data) {
    return (dispatch) => {
        serviceUpdateAppUsers(data).then((data) => {
            if (!data.error) {
                dispatch({ type: UPDATE_DATA, payload: data.data })
            }
        })
    }
}

export function actionDeleteAppUsers(id) {
    return (dispatch) => {
        serviceDeleteAppUsers({ id });
        dispatch({ type: DELETE_ITEM, payload: id })
    }
}

export function actionChangePageAppUsersRequests(page) {
    return (dispatch) => {
        dispatch({ type: CHANGE_PAGE, payload: page })
    }
}

export function actionResetFilterAppUsers() {
    return {
        type: RESET_FILTER
    };
}

export function actionSetPageAppUsers(page) {

    const stateData = store.getState().appusers;

    const totalLength = stateData.all.length;
    const sortingData = stateData.sorting_data;
    const query = stateData.query;
    const queryData = stateData.query_data;
    const serverPage = stateData.serverPage;

    if (totalLength <= ((page + 1) * Constants.DEFAULT_PAGE_VALUE)) {
        store.dispatch(
            actionFetchAppUsers(
                serverPage + 1,
                sortingData,
                { query, query_data: queryData }
            )
        );
    }

    return {
        type: CHANGE_PAGE,
        payload: page,
    };
}